import { genericRequest } from "./genericRequest";

const route = "api/Checklist/";

export async function getChecklist(id) {
  return await genericRequest('GET', 
    route + 'Get/' + encodeURIComponent(id));
}

export async function search(params) {
  return await genericRequest('POST', 
    route + "Search", 
    undefined, JSON.stringify(params));
}

export async function getSchedules2Parameters() {
  return await genericRequest('GET',
    route + "Schedules2Parameters");
}

export async function getSchedules2() {
  return await genericRequest('GET', 
    route + "Schedules2");
}

export async function getSchedules2History(checklistScheduleId, before) {
  return await genericRequest('GET',
    route + "Schedules2/" + 
    encodeURIComponent(checklistScheduleId) + 
    "/History", before ? { before } : undefined);
}

export async function postSchedule2(data) {
  return await genericRequest('POST',
    route + "Schedules2", null, data);
}

export async function patchSchedule2(data) {
  return await genericRequest('PATCH',
    route + "Schedules2", null, data);
}

export async function deleteSchedule2(id) {
  return await genericRequest('DELETE',
    route + "Schedule2/" + encodeURIComponent(id));
}

// old ----------------------------------

export async function getSchedule(params) {
  return await genericRequest('POST', 
    route + "GetSchedule", 
    undefined, JSON.stringify(params));
}

export async function getReports() {
  return await genericRequest('GET', 
    route + "Reports");
}

export async function updateDateCompleted(event) {
  return await genericRequest('POST', 
    route + "UpdateCompletedDate", 
    undefined, JSON.stringify(event));
}

export async function insertSchedule(event) {
  return await genericRequest('POST', 
    route + "InsertSchedule", 
    undefined, JSON.stringify(event));
}

export async function updateSchedule(event) {
  return await genericRequest('POST', 
    route + "UpdateSchedule", 
    undefined, JSON.stringify(event));
}

export async function updateScheduleIndividual(event) {
  return await genericRequest('POST', 
    route + "UpdateScheduleIndividual", 
    undefined, JSON.stringify(event));
}

export async function removeSchedule(event) {
  return await genericRequest('POST', 
    route + "RemoveSchedule", 
    undefined, JSON.stringify(event));
}

export async function getLastLocation() {
  return await genericRequest('GET', 
    route + "LastLocation");
}
